import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { WatchListNotificationViewModel, WatchListItemNew, WatchListViewModel } from '../models/watch-list.model';
import { ApiResponse } from '../models/api-response.model';
import { AuthService } from "./auth.service";

@Injectable()
export class WatchListService {

    Products: WatchListItemNew[] = [];
    baseUrl = '/api/watchlist';
    status: string = "";

    private watchSubject = new BehaviorSubject<string>(this.status);
    currentWatch = this.watchSubject.asObservable();

    constructor(private http: HttpClient,
        private authService: AuthService
        ) { }

    monitorWatchListItemChange(status: string): void {
        this.watchSubject.next(status);
    }

    insertWatchList(stockCode: string[]): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl+"/AddItemsToWatchList", stockCode)
            .pipe(catchError(this.authService.handleError));
    }

    deleteWatchList(stockCode: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/DeleteItem?stockCode='+stockCode)
            .pipe(catchError(this.authService.handleError));
    }

    getWatchList(): Observable<WatchListItemNew[]> {
        return this.http.get<WatchListItemNew[]>(this.baseUrl + '/GetAllItems')
            .pipe(catchError(this.authService.handleError));
    }

    GetWatchListViewModel(): Observable<WatchListViewModel> {
        return this.http.get<WatchListViewModel>(this.baseUrl + '/GetWatchListViewModel')
            .pipe(catchError(this.authService.handleError));
    }

    updateWatchListNotification(product: WatchListNotificationViewModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/updatenotification', product)
            .pipe(catchError(this.authService.handleError));
    }

    deleteWatchListNotification(stockCode: string): Observable<ApiResponse> {
        return this.http.delete<ApiResponse>(this.baseUrl + '/deletenotification?stockCode=' + stockCode)
            .pipe(catchError(this.authService.handleError));
    }

}
